import { render, staticRenderFns } from "./OrderItems.html?vue&type=template&id=f34d9480&scoped=true&"
import script from "./OrderItems.js?vue&type=script&lang=js&"
export * from "./OrderItems.js?vue&type=script&lang=js&"
import style0 from "./OrderItems.scss?vue&type=style&index=0&id=f34d9480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34d9480",
  null
  
)

export default component.exports